export default __webpack_public_path__ + "static/media/add.85dd6482.svg";